import { CSSProperties } from 'react';

import styles from './index.module.sass';

interface OuterLinkProps {
  onClick?(): void;
  href: string;
  children: JSX.Element;
  className?: string;
  self?: boolean;
  style?: CSSProperties;
}

const OuterLink = ({
  onClick,
  href,
  children,
  className,
  self,
  style,
}: OuterLinkProps) => {
  return (
    <a
      href={href}
      style={style}
      target={self ? '_self' : '_blank'}
      rel="noreferrer noopener"
      className={`${styles['outer-link']} ${className}`}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {children}
    </a>
  );
};

export default OuterLink;
